import { createContext } from 'react';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { BlankIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarComponent = () => /*#__PURE__*/_jsx(IconCircle, {
  icon: BlankIcon,
  size: "300",
  color: "fill-tertiary-default",
  borderWidth: "0",
  backgroundColor: "fill-tertiary-default"
});
AvatarComponent.displayName = 'DefaultAvatarComponent';
const MessageHistoryContext = /*#__PURE__*/createContext({
  AvatarComponent
});
export default MessageHistoryContext;